module.exports = __webpack_public_path__ + "img/54_25.2c0665b8.png";